<template>
	<el-drawer title="聊天记录" :size="drawerSize" :visible.sync="isShow" direction="rtl" :before-close="close"
		custom-class="chat-history-drawer">
		<div class="chat-history">
			<div class="search-bar">
				<el-input class="search-text" size="small" placeholder="搜索聊天记录关键词" v-model="searchText"
					@input="onSearchTextChange">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
			</div>
			<div class="chat-tabs" ref="chatTabs" v-loading="loading">
				<el-tabs v-model="tabName" @tab-click="onTabClick">
					<el-tab-pane label="全部" name="all">
						<el-scrollbar v-if="messageSize > 0" ref="allScrollBox" :style="tabPaneStyle">
							<div v-for="(msgInfo, idx) in showMessages" :key="messageKey(msgInfo)">
								<chat-history-item @click.native="onClickItem(idx)"
									@contextmenu.prevent.native="onRclickItem($event, idx)"
									@dblclick.native="onDblclickItem(idx)"
									:active="activeIdx == idx" :headImage="headImage(msgInfo)"
									:showName="showName(msgInfo)" :quoteShowName="showName(msgInfo.quoteMessage)"
									:msgInfo="msgInfo">
								</chat-history-item>
							</div>
						</el-scrollbar>
						<no-data-tip v-else :style="tabPaneStyle" :tip="noDataTip"></no-data-tip>
					</el-tab-pane>
					<el-tab-pane label="文字" name="text">
						<el-scrollbar v-if="messageSize > 0" ref="textScrollBox" :style="tabPaneStyle">
							<div v-for="(msgInfo, idx) in showMessages" :key="messageKey(msgInfo)">
								<chat-history-item @click.native="onClickItem(idx)"
									@contextmenu.prevent.native="onRclickItem($event, idx)"
									@dblclick.native="onDblclickItem(idx)"
									:active="activeIdx == idx" :headImage="headImage(msgInfo)"
									:showName="showName(msgInfo)" :quoteShowName="showName(msgInfo.quoteMessage)"
									:msgInfo="msgInfo">
								</chat-history-item>
							</div>
						</el-scrollbar>
						<no-data-tip v-else :style="tabPaneStyle" :tip="noDataTip"></no-data-tip>
					</el-tab-pane>
					<el-tab-pane label="图片" name="image">
						<el-scrollbar v-if="messageSize > 0" ref="imageScrollBox" :style="tabPaneStyle">
							<div v-for="(msgInfo, idx) in showMessages" :key="messageKey(msgInfo)">
								<chat-history-item @click.native="onClickItem(idx)"
									@contextmenu.prevent.native="onRclickItem($event, idx)"
									@dblclick.native="onDblclickItem(idx)"
									:active="activeIdx == idx" :headImage="headImage(msgInfo)"
									:showName="showName(msgInfo)" :quoteShowName="showName(msgInfo.quoteMessage)"
									:msgInfo="msgInfo">
								</chat-history-item>
							</div>
						</el-scrollbar>
						<no-data-tip v-else :style="tabPaneStyle"></no-data-tip>
					</el-tab-pane>
					<el-tab-pane label="表情" name="sticker">
						<el-scrollbar v-if="messageSize > 0" ref="stickerScrollBox" :style="tabPaneStyle">
							<div v-for="(msgInfo, idx) in showMessages" :key="messageKey(msgInfo)">
								<chat-history-item @click.native="onClickItem(idx)"
									@contextmenu.prevent.native="onRclickItem($event, idx)"
									@dblclick.native="onDblclickItem(idx)"
									:active="activeIdx == idx" :headImage="headImage(msgInfo)"
									:showName="showName(msgInfo)" :quoteShowName="showName(msgInfo.quoteMessage)"
									:msgInfo="msgInfo">
								</chat-history-item>
							</div>
						</el-scrollbar>
						<no-data-tip v-else :style="tabPaneStyle"></no-data-tip>
					</el-tab-pane>
					<el-tab-pane label="文件" name="file">
						<el-scrollbar v-if="messageSize > 0" ref="fileScrollBox" :style="tabPaneStyle">
							<div v-for="(msgInfo, idx) in showMessages" :key="messageKey(msgInfo)">
								<chat-history-item @click.native="onClickItem(idx)"
									@contextmenu.prevent.native="onRclickItem($event, idx)"
									@dblclick.native="onDblclickItem(idx)"
									:active="activeIdx == idx" :headImage="headImage(msgInfo)"
									:showName="showName(msgInfo)" :quoteShowName="showName(msgInfo.quoteMessage)"
									:msgInfo="msgInfo">
								</chat-history-item>
							</div>
						</el-scrollbar>
						<no-data-tip v-else :style="tabPaneStyle" :tip="noDataTip"></no-data-tip>
					</el-tab-pane>
					<el-tab-pane label="语音" name="voice">
						<el-scrollbar v-if="messageSize > 0" ref="voiceScrollBox" :style="tabPaneStyle">
							<div v-for="(msgInfo, idx) in showMessages" :key="messageKey(msgInfo)">
								<chat-history-item @click.native="onClickItem(idx)"
									@contextmenu.prevent.native="onRclickItem($event, idx)"
									@dblclick.native="onDblclickItem(idx)"
									:active="activeIdx == idx" :headImage="headImage(msgInfo)"
									:showName="showName(msgInfo)" :quoteShowName="showName(msgInfo.quoteMessage)"
									:msgInfo="msgInfo">
								</chat-history-item>
							</div>
						</el-scrollbar>
						<no-data-tip v-else :style="tabPaneStyle"></no-data-tip>
					</el-tab-pane>
					<el-tab-pane label="视频" name="video">
						<el-scrollbar v-if="messageSize > 0" ref="videoScrollBox" :style="tabPaneStyle">
							<div v-for="(msgInfo, idx) in showMessages" :key="messageKey(msgInfo)">
								<chat-history-item @click.native="onClickItem(idx)"
									@contextmenu.prevent.native="onRclickItem($event, idx)"
									@dblclick.native="onDblclickItem(idx)"
									:active="activeIdx == idx" :headImage="headImage(msgInfo)"
									:showName="showName(msgInfo)" :quoteShowName="showName(msgInfo.quoteMessage)"
									:msgInfo="msgInfo">
								</chat-history-item>
							</div>
						</el-scrollbar>
						<no-data-tip v-else :style="tabPaneStyle"></no-data-tip>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
	</el-drawer>
</template>

<script>
import ChatHistoryItem from './ChatHistoryItem.vue';
import RightMenu from '../common/RightMenu.vue';
import NoDataTip from '../common/NoDataTip.vue';
import { getDB } from '../../db/index.js';

const PAGE_SIZE = 30;

export default {
	name: 'chatHistory',
	components: {
		ChatHistoryItem,
		RightMenu,
		NoDataTip
	},
	props: {
		chat: {
			type: Object
		},
		friend: {
			type: Object
		},
		group: {
			type: Object
		},
		groupMembers: {
			type: Array,
		}
	},
	data() {
			return {
				isShow: false,
				tabName: "all",
				activeIdx: -1,
				searchText: '',
				tabPaneHeight: 500,
				historyMessages: [],
				cursor: null,
				more: false,
				loading: false,
				loadGeneration: 0,
				searchTimer: null,
			menuItems: [{
				key: 'LOCATE_QUOTE',
				name: '在聊天中定位',
				icon: 'el-icon-location'
			}]
		}
	},
	watch: {
		'chat.messageRemovalCutoffs': {
			deep: true,
			handler() {
				if (this.isShow) this.loadPage(true);
			}
		}
	},
	methods: {
		async open() {
			this.isShow = true;
			this.searchText = '';
			this.tabName = 'all';
			await this.$nextTick();
			if (this.$refs.chatTabs) {
				// 滚动条高度
				this.tabPaneHeight = this.$refs.chatTabs.offsetHeight - 80;
			}
			await this.loadPage(true);
		},
		close() {
			this.isShow = false;
			this.loadGeneration++;
			if (this.searchTimer) clearTimeout(this.searchTimer);
		},
		async onTabClick() {
			await this.loadPage(true);
		},
		onScroll(e) {
			const scrollElement = e.target;
			if (scrollElement.scrollTop < 30) this.loadPage(false, scrollElement);
		},
		onSearchTextChange() {
			if (this.searchTimer) clearTimeout(this.searchTimer);
			this.searchTimer = setTimeout(() => this.loadPage(true), 250);
		},
		onClickItem(idx) {
			this.activeIdx = idx;
		},
		onDblclickItem(idx) {
			this.activeIdx = idx;
			this.onSelectMenu(this.menuItems[0]);
		},
		onRclickItem(e, idx) {
			this.activeIdx = idx;
			this.$refs.rightMenu.open(e, this.menuItems)
		},
		async onSelectMenu(item) {
			const message = this.historyMessages[this.activeIdx];
			if (!message) return;
			try {
				await this.hydrateLocateContext(message);
			} catch (error) {
				console.error('[chat-history] 加载定位上下文失败', error);
				this.$message.error('加载消息上下文失败，请重试');
				return;
			}
			// 菜单id转驼峰作为事件key
			const eventKey = item.key.toLowerCase().replace(/_([a-z])/g, (g) => g[1].toUpperCase());
			this.$emit(eventKey, message);
		},
		messageKey(message) {
			return message.localId || `id:${message.id}`;
		},
		conversationKey() {
			return `${this.chat.type}-${this.chat.targetId}`;
		},
		messageTypesForTab() {
			const type = this.$enums.MESSAGE_TYPE;
			const mapping = {
				all: [type.TEXT, type.IMAGE, type.FILE, type.AUDIO, type.VIDEO, type.USER_CARD,
					type.GROUP_CARD, type.STICKER, type.MERGE_FORWARD, type.ACT_RT_VOICE, type.ACT_RT_VIDEO],
				text: [type.TEXT],
				image: [type.IMAGE],
				sticker: [type.STICKER],
				file: [type.FILE],
				voice: [type.AUDIO],
				video: [type.VIDEO]
			};
			return mapping[this.tabName] || mapping.all;
		},
		async loadPage(reset, scrollElement = null) {
			if (!reset && (this.loading || !this.more)) return;
			const generation = reset ? ++this.loadGeneration : this.loadGeneration;
			const previousHeight = scrollElement ? scrollElement.scrollHeight : 0;
			if (reset) {
				this.historyMessages = [];
				this.cursor = null;
				this.more = true;
				this.activeIdx = -1;
			}
			this.loading = true;
			try {
				if (reset) await this.chatStore.flushPersistence();
				const rows = await getDB().findMessagesByTypes(
					this.conversationKey(),
					this.messageTypesForTab(),
					reset ? null : this.cursor,
					PAGE_SIZE + 1,
					this.searchText
				);
				if (generation !== this.loadGeneration) return;
				const descendingPage = rows.slice(0, PAGE_SIZE);
				const chronologicalPage = descendingPage.slice().reverse();
				if (reset) this.historyMessages = chronologicalPage;
				else {
					this.historyMessages = chronologicalPage.concat(this.historyMessages);
					if (this.activeIdx >= 0) this.activeIdx += chronologicalPage.length;
				}
				this.more = rows.length > PAGE_SIZE;
				this.cursor = descendingPage.length ? Number(descendingPage[descendingPage.length - 1].seqNo) || null : null;
				await this.$nextTick();
				this.initEvent();
				if (reset) this.scrollToBottom();
				else if (scrollElement) scrollElement.scrollTop = scrollElement.scrollHeight - previousHeight;
			} catch (error) {
				if (generation === this.loadGeneration) {
					console.error('[chat-history] 加载历史记录失败', error);
					this.$message.error('聊天记录加载失败，请重试');
				}
			} finally {
				if (generation === this.loadGeneration) this.loading = false;
			}
		},
		async hydrateLocateContext(message) {
			const seqNo = Number(message && message.seqNo);
			const rows = Number.isFinite(seqNo) && seqNo > 0
				? await getDB().findMessagesBefore(this.conversationKey(), seqNo + 1, PAGE_SIZE)
				: [message];
			this.chatStore.mergeHistoryMessages(rows.length ? rows : [message], this.chat, { source: 'local-db-page' });
		},
		initEvent() {
			if (!this.messageSize) {
				return;
			}
			this.$nextTick(() => {
					const scrollBoxName = this.tabName + "ScrollBox";
					const scrollBox = this.$refs[scrollBoxName];
					if (!scrollBox || !scrollBox.$el) return;
					const scrollWrap = scrollBox.$el.querySelector('.el-scrollbar__wrap');
				scrollWrap.removeEventListener('scroll', this.onScroll)
				scrollWrap.addEventListener('scroll', this.onScroll);
			})
		},
		showName(msgInfo) {
			if (!msgInfo)
				return '';
			if (this.isGroup) {
				let member = this.findGroupMember(msgInfo.sendId);
				return member ? member.showNickName : msgInfo.sendNickName || "";
			} else {
				return msgInfo.selfSend ? this.mine.nickName : this.chat.showName
			}
		},
		headImage(msgInfo) {
			if (this.isGroup) {
				let member = this.findGroupMember(msgInfo.sendId);
				return member ? member.headImage : "";
			} else {
				return msgInfo.selfSend ? this.mine.headImageThumb : this.chat.headImage
			}
		},
		findGroupMember(userId) {
			if (!this.group || !this.group.id || userId === undefined || userId === null) {
				return null;
			}
			return this.groupStore.findGroupMember(this.group.id, userId);
		},
		showMenu(e) {
			this.rightMenu.pos = {
				x: e.x,
				y: e.y
			};
			this.rightMenu.show = "true";
		},
		showFullImageBox(msgInfo) {
			const content = JSON.parse(msgInfo.content);
			let imageUrl = content.originUrl || content.thumbUrl;
			if (imageUrl) {
				if (!this.$assetResolver.hasAssetSource(imageUrl)) {
					this.$message.error('图片暂不可用');
					return;
				}
				this.$eventBus.$emit("openFullImage", {
					url: imageUrl,
					strict: true,
					kind: 'image',
					fileName: content.name || content.fileName || 'image',
					contentType: content.contentType || content.mimeType || 'image/*'
				});
			}
		},
		scrollToBottom() {
			if (!this.messageSize) {
				return;
			}
			this.$nextTick(() => {
				const scrollBoxName = this.tabName + "ScrollBox";
				const scrollBox = this.$refs[scrollBoxName];
				if (!scrollBox || !scrollBox.$el) return;
				const scrollWrap = scrollBox.$el.querySelector('.el-scrollbar__wrap');
				scrollWrap.scrollTop = scrollWrap.scrollHeight;
			});
		}
	},
	computed: {
		drawerSize() {
			return this.configStore.isMobile ? '100%' : 'clamp(460px, 40vw, 640px)';
		},
		mine() {
			return this.userStore.userInfo;
		},
		isGroup() {
			return this.chat.type == 'GROUP';
		},
		showMessages() {
			return this.historyMessages;
		},
		messageSize() {
			return this.isShow ? this.historyMessages.length : 0;
		},
		tabPaneStyle() {
			return `height:${this.tabPaneHeight}px`;
		},
		noDataTip() {
			return this.searchText ? `未搜索到与'${this.searchText}'相关的内容` : "没有数据";
		}
	},
	beforeDestroy() {
		if (this.searchTimer) clearTimeout(this.searchTimer);
		this.loadGeneration++;
	}
}
</script>

<style lang="scss">
.chat-history-drawer {
	border-radius: 0 !important;
	box-shadow: none !important;

	.el-drawer__header {
		padding: 14px 16px 10px;
		margin-bottom: 0;
		border-bottom: 1px solid var(--im-surface-panel-border);
	}
}

.chat-history {
	display: flex;
	height: 100%;
	padding: 0 12px 12px;
	flex-direction: column;
	gap: 8px;

	.search-bar {
		flex-shrink: 0;
		padding-top: 2px;

		::v-deep .el-input__inner {
			height: 36px;
			line-height: 36px;
			padding-left: 38px;
			border-radius: 6px;
			border: 1px solid var(--im-control-border);
			background: var(--im-control-bg);
			box-shadow: none;
		}

		::v-deep .el-input__inner:focus {
			border-color: var(--im-control-border-strong);
			box-shadow: none;
		}

		::v-deep .el-input__prefix {
			left: 6px;
			color: var(--im-text-color-light);
		}

		::v-deep .el-input__icon {
			width: 22px;
			height: 22px;
			border-radius: 4px;
			background: transparent;
		}
	}

	.chat-tabs {
		flex: 1;
		min-height: 0;

		::v-deep .el-tabs {
			display: flex;
			height: 100%;
			flex-direction: column;
		}

		::v-deep .el-tabs__header {
			margin-bottom: 6px;
			flex-shrink: 0;
		}

		::v-deep .el-tabs__item {
			height: 32px;
			line-height: 32px;
			font-size: 12px;
			padding: 0 12px;
		}

		::v-deep .el-tabs__nav-wrap::after {
			height: 1px;
			background: var(--im-surface-panel-border);
		}

		::v-deep .el-tabs__content {
			flex: 1;
			min-height: 0;
		}

		::v-deep .el-tab-pane {
			height: 100%;
		}
	}
}

@media (max-width: 640px) {
	.chat-history {
		padding: 0 12px 12px;
		gap: 8px;

		.chat-tabs {
			::v-deep .el-tabs__item {
				padding: 0 10px;
			}
		}
	}
}
</style>
